declare const window: any;


let branch = 'develop';
if (typeof window !== 'undefined' && window.__env && window.__env.branchName) {
	branch = window.__env.branchName;
}
console.log('USING BRANCH:', branch);

const environments: { [key: string]: any } = {
	sandbox: {
		environment: {
			production: false,
			cloudinary: {
				api_key: '321842221971572',
				cloud_name: 'ddqvtwvdk',
				api_secret: 'ICDezxj5Oqm0cHRrZ8jeKT6IAUk',
				upload: {
					url: 'https://api.cloudinary.com/v1_1/ddqvtwvdk/image/upload',
				},
				delete: {
					url: 'https://api.cloudinary.com/v1_1/ddqvtwvdk/image/destroy',
				}
			},
			emails_url: 'https://us-central1-quanto-software.cloudfunctions.net/emails-emails',
			api: 'https://api.testing.quantopos.com',
			// sandbox.search.quantopos.com no está enrutando a Typesense (404 de otra app) — se usa
			// la IP del servidor directo con una key search-only (documents:search, sin escritura).
			typesense: 'http://140.82.63.158:8108',
			typesenseSearchKey: 'SyHoKWfN89eNuGDiIsIrbwvY7ZJWbemG',
		},
		firebaseConfig: {
			apiKey: "AIzaSyBmreAMoptKaFVLWQb_oOl4agWhFR-KVA4",
			authDomain: "quanto-sandbox.firebaseapp.com",
			projectId: "quanto-sandbox",
			storageBucket: "quanto-sandbox.appspot.com",
			messagingSenderId: "451046662365",
			appId: "1:451046662365:web:9ca520c09b78cb719a3b34",
			measurementId: "G-SNN16Z8RDE"
		}
	},
	develop: {
		environment: {
			production: false,
			cloudinary: {
				api_key: '321842221971572',
				cloud_name: 'ddqvtwvdk',
				api_secret: 'ICDezxj5Oqm0cHRrZ8jeKT6IAUk',
				upload: {
					url: 'https://api.cloudinary.com/v1_1/ddqvtwvdk/image/upload',
				},
				delete: {
					url: 'https://api.cloudinary.com/v1_1/ddqvtwvdk/image/destroy',
				}
			},
			emails_url: 'https://us-central1-quanto-software.cloudfunctions.net/emails-emails',
			api: 'https://api.testing.quantopos.com',
			// Antes no tenía typesense configurado en absoluto (el servicio quedaba apuntando a
			// undefined/search) — misma IP + key search-only que sandbox, comparten el mismo server.
			typesense: 'http://140.82.63.158:8108',
			typesenseSearchKey: 'SyHoKWfN89eNuGDiIsIrbwvY7ZJWbemG',
		},
		firebaseConfig: {
			apiKey: "AIzaSyCXQ5pc8OrB4sm8KBJSFKs10ooPWyNirQ4",
			authDomain: "quanto-develop.firebaseapp.com",
			databaseURL: "https://quanto-develop-default-rtdb.firebaseio.com",
			projectId: "quanto-develop",
			storageBucket: "quanto-develop.appspot.com",
			messagingSenderId: "587942193426",
			appId: "1:587942193426:web:12fe044950532a7f75abcb"
		},
		prod: {
			environment: {
				production: true,
				cloudinary: {
					api_key: '321842221971572',
					cloud_name: 'ddqvtwvdk',
					api_secret: 'ICDezxj5Oqm0cHRrZ8jeKT6IAUk',
					upload: {
						url: 'https://api.cloudinary.com/v1_1/ddqvtwvdk/image/upload',
					},
					delete: {
						url: 'https://api.cloudinary.com/v1_1/ddqvtwvdk/image/destroy',
					}
				},
				emails_url: 'https://us-central1-quanto-software.cloudfunctions.net/emails-emails',
				api: 'https://api.quantopos.com'
			},
			firebaseConfig: {
				apiKey: "AIzaSyBZPFTnJE76B_gAVNzcQqcVqy8006iendM",
				authDomain: "quanto-software.firebaseapp.com",
				projectId: "quanto-software",
				storageBucket: "quanto-software.appspot.com",
				messagingSenderId: "22922072346",
				appId: "1:22922072346:web:a5ecae40e3805b15361ca3",
				measurementId: "G-FWTGWXFC0J"
			}
		},
	},
	prod: {
		environment: {
			production: true,
			api_url: "",
			payment_url: "",
			target: 'app',
			updateCheckEnabled: false,
			cloudinary: {
				api_key: '321842221971572',
				cloud_name: 'ddqvtwvdk',
				api_secret: 'ICDezxj5Oqm0cHRrZ8jeKT6IAUk',
				upload: {
					url: 'https://api.cloudinary.com/v1_1/ddqvtwvdk/image/upload',
				},
				delete: {
					url: 'https://api.cloudinary.com/v1_1/ddqvtwvdk/image/destroy',
				}
			},
			emails_url: 'https://us-central1-quanto-software.cloudfunctions.net/emails-emails',
			mh: {
				environment: '01',
				url: 'https://api.dtes.mh.gob.sv'
			},
			api: 'https://api.quantopos.com',
			solutions_url: 'https://solutions.quantopos.com',
			// `search.quantopos.com` es un **proxy**, no Typesense: expone `/search?collection=...`
			// y guarda la API key del lado del servidor. Por eso aqui no va `typesenseSearchKey`
			// (iria en el bundle del navegador) y hace falta la bandera: sin ella el servicio pide
			// el path nativo `/collections/.../documents/search`, que este host no expone -> 404.
			//
			// No se apunta al Typesense directo por IP porque es HTTP y la app corre sobre HTTPS
			// (`capacitor.config.ts`: url https://cdn.quantopos.com/apps/abc/, cleartext: false):
			// el navegador bloquea la peticion como contenido mixto.
			typesense: 'https://search.quantopos.com',
			typesenseProxy: true,
		},
		firebaseConfig: {
			apiKey: "AIzaSyBZPFTnJE76B_gAVNzcQqcVqy8006iendM",
			authDomain: "quanto-software.firebaseapp.com",
			projectId: "quanto-software",
			storageBucket: "quanto-software.appspot.com",
			messagingSenderId: "22922072346",
			appId: "1:22922072346:web:a5ecae40e3805b15361ca3",
			measurementId: "G-FWTGWXFC0J"
		}

	}
};

console.log(environments[branch]?.environment.typesense);

export const environment = environments[branch]?.environment || environments['develop'].environment;
export const firebaseConfig = environments[branch]?.firebaseConfig || environments['develop'].firebaseConfig;